import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataTablesModule } from "angular-datatables";

import { NgxLoadingModule } from 'ngx-loading';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { MatTabsModule } from '@angular/material/tabs';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';

import { TenderDetailComponent } from './tender-detail/tender-detail.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { RenewSubscriptionComponent } from './renew-subscription/renew-subscription.component';
import { TenderAlertComponent } from './tender-alert/tender-alert.component';


@NgModule({
    imports: [
        NgbModule,MatTabsModule,
        CommonModule,CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        ReactiveFormsModule,
        DataTablesModule,
        NgxLoadingModule.forRoot({})
     ],
    declarations: [
        TenderDetailComponent,
        UpdatePasswordComponent,
        RenewSubscriptionComponent,
        TenderAlertComponent
    ],
    exports: [
        TenderDetailComponent,
        UpdatePasswordComponent,
        RenewSubscriptionComponent,
        TenderAlertComponent
    ],
    entryComponents: [
        TenderDetailComponent,
        UpdatePasswordComponent,
        RenewSubscriptionComponent,
        TenderAlertComponent
    ]
})
export class SharedModule {}